/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Subscription_ManagementInputs */

const en_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Subscriptions`)
};

const ar_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدارة الاشتراكات`)
};

const de_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements verwalten`)
};

const es_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionar suscripciones`)
};

const fr_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer les abonnements`)
};

const it_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci abbonamenti`)
};

const ja_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションを管理`)
};

const ko_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 관리`)
};

const pt_br_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciar assinaturas`)
};

const ru_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление подписками`)
};

const th_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดการการสมัครสมาชิก`)
};

const tr_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelikleri Yönet`)
};

const zh_cn_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往 Plus 会员管理`)
};

const zh_tw_btn_subscription_management = /** @type {(inputs: Btn_Subscription_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前往訂閱管理`)
};

/**
* | output |
* | --- |
* | "Manage Subscriptions" |
*
* @param {Btn_Subscription_ManagementInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_subscription_management = /** @type {((inputs?: Btn_Subscription_ManagementInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Subscription_ManagementInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_subscription_management(inputs)
	if (locale === "ar") return ar_btn_subscription_management(inputs)
	if (locale === "de") return de_btn_subscription_management(inputs)
	if (locale === "es") return es_btn_subscription_management(inputs)
	if (locale === "fr") return fr_btn_subscription_management(inputs)
	if (locale === "it") return it_btn_subscription_management(inputs)
	if (locale === "ja") return ja_btn_subscription_management(inputs)
	if (locale === "ko") return ko_btn_subscription_management(inputs)
	if (locale === "pt_br") return pt_br_btn_subscription_management(inputs)
	if (locale === "ru") return ru_btn_subscription_management(inputs)
	if (locale === "th") return th_btn_subscription_management(inputs)
	if (locale === "tr") return tr_btn_subscription_management(inputs)
	if (locale === "zh_cn") return zh_cn_btn_subscription_management(inputs)
	return zh_tw_btn_subscription_management(inputs)
});